import { Fragment, useState } from 'react';

const BankWelcome = ({ state, updateState, nextStep, changeStage, }) => {
  const [hasAccount, setHasAccount] = useState(state?.data?.bank_options?.has_account === false ? false : true);
  const [hasStatements, setHasStatements] = useState(state?.data?.bank_options?.has_statements === false ? false : true);

  const onSubmit = (e) => {
    e.preventDefault();

    updateState('bank_options', {
      has_account: hasAccount,
      has_statements: hasStatements,
    });

    if (hasAccount === true) {
      nextStep(null, 'bank-verification');
      return;
    }

    if (hasStatements === true) {
      nextStep(null, 'card-processing');
      return;
    }

    changeStage('people-with-significant-control');
    nextStep(null, 'posc-welcome');
  };

  return (
    <Fragment>
      <div>
        <h1 className="text-2xl font-semibold mb-6">Proof of Banking & Processing</h1>

        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
          <div className="gap-x-4 sm:col-span-2">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
              Do you have a trading bank account setup and ready to use?
            </label>
            <div className="mt-2.5 clear">
              <ul
                className="items-center w-full text-sm font-medium text-gray-900 bg-white border rounded-lg sm:flex bg-gray-100 border-gray-300">
                <li
                  onClick={() => setHasAccount(true)}
                  className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300">
                  <div className="flex items-center cursor-pointer">
                    <input id="horizontal-list-radio-license" type="radio" value="" name="list-statements" checked={hasAccount === true} onChange={() => setHasAccount(true)}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 bg-gray-500 border-gray-300 cursor-pointer" />
                    <label htmlFor="horizontal-list-radio-license"
                      className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">Yes</label>
                  </div>
                </li>
                <li
                  onClick={() => setHasAccount(false)}
                  className="w-full border-b border-gray-300 sm:border-b-0 sm:border-r dark:border-gray-300">
                  <div className="flex items-center cursor-pointer">
                    <input id="horizontal-list-radio-id" type="radio" value="" name="list-statements" checked={hasAccount === false} onChange={() => setHasAccount(false)}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 border-gray-300 cursor-pointer" />
                    <label htmlFor="horizontal-list-radio-id"
                      className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">No</label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2 mt-10">
          <div className="gap-x-4 sm:col-span-2">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
              Do you have 3 months of card processing statements?
            </label>
            <div className="mt-2.5 clear">
              <ul
                className="items-center w-full text-sm font-medium text-gray-900 bg-white border rounded-lg sm:flex bg-gray-100 border-gray-300 cursor-pointer">
                <li
                  onClick={() => setHasStatements(true)}
                  className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300">
                  <div className="flex items-center">
                    <input id="horizontal-list-radio" type="radio" value="" name="list-radio" checked={hasStatements === true} onChange={() => setHasStatements(true)}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 bg-gray-500 border-gray-300 cursor-pointer" />
                    <label htmlFor="horizontal-list-radio"
                      className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">Yes</label>
                  </div>
                </li>
                <li
                  onClick={() => setHasStatements(false)}
                  className="w-full border-b border-gray-300 sm:border-b-0 sm:border-r dark:border-gray-300 cursor-pointer">
                  <div className="flex items-center">
                    <input id="horizontal-list-radio-x" type="radio" value="" name="list-radio" checked={hasStatements === false} onChange={() => setHasStatements(false)}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 border-gray-300 cursor-pointer" />
                    <label htmlFor="horizontal-list-radio-x"
                      className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">No</label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12">
          <button type="submit"
            onClick={(e) => onSubmit(e)}
            className="bg-purple-800 disabled:bg-purple-200 hover:bg-purple-900 text-white font-semibold rounded-md py-2 px-4 w-full">
            Next
          </button>
        </div>
      </div>

    </Fragment>
  );
}

export default BankWelcome;
